var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftConfetti({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6002 122.574L70.0059 128.408L60.3287 132.9L49.5124 137.919L41.7058 141.54L33.4917 145.346L27.6113 148.069L21.4808 150.912L16.7579 153.107L11.3127 155.635L7.6178 157.349L2.22818 159.849C0.903925 160.46 -0.466631 159.09 0.153823 157.775L2.66342 152.394L4.37662 148.708L6.92326 143.272L9.118 138.568L11.9702 132.446L14.7021 126.593L18.5267 118.407L22.1568 110.628L27.1945 99.8479L31.6766 90.2259L37.733 77.2422L82.5909 122.546L82.6002 122.574Z",
    fill: "url(#paint0_linear_29716_8594)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3114 155.646L7.61648 157.359C6.72747 156.646 5.84773 155.859 4.99576 155.007C4.14379 154.155 3.36591 153.294 2.66211 152.405L4.3753 148.719C5.30136 149.978 6.37558 151.228 7.57018 152.423C8.76479 153.618 10.0335 154.701 11.3114 155.637V155.646Z",
    fill: "url(#paint1_linear_29716_8594)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4906 150.921L16.7678 153.116C14.9434 151.838 13.1376 150.329 11.4059 148.597C9.69272 146.884 8.19252 145.087 6.92383 143.29L9.11857 138.586C10.5725 140.901 12.4338 143.216 14.6101 145.402C16.8141 147.606 19.1477 149.467 21.4906 150.931V150.921Z",
    fill: "url(#paint2_linear_29716_8594)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4921 145.357L27.6117 148.08C24.6669 146.274 21.685 143.931 18.879 141.125C16.0731 138.319 13.7765 135.393 11.9707 132.466L14.7026 126.613C16.6287 130.188 19.3421 133.865 22.7407 137.263C26.1763 140.699 29.8805 143.431 33.4921 145.357Z",
    fill: "url(#paint3_linear_29716_8594)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0086 128.408L60.3314 132.899C53.9139 129.899 47.1907 125.166 41.014 118.989C34.8928 112.868 30.2069 106.219 27.1973 99.8564L31.6794 90.2344C34.476 97.6245 39.736 105.672 47.0333 112.97C54.3954 120.332 62.5539 125.639 70.0086 128.398V128.408Z",
    fill: "url(#paint4_linear_29716_8594)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.513 137.927L41.7064 141.548C37.2706 139.075 32.7515 135.667 28.5472 131.454C24.3429 127.24 20.9999 122.813 18.5273 118.424L22.1575 110.645C24.6763 115.886 28.5565 121.35 33.6035 126.397C38.6875 131.481 44.2253 135.399 49.513 137.918V137.927Z",
    fill: "url(#paint5_linear_29716_8594)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M63.5318 103.316L0.125 159.02C0.282429 159.4 0.569506 159.696 0.939927 159.863L77.8393 117.763L63.5318 103.316Z",
    fill: "url(#paint6_linear_29716_8594)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3011 121.869C79.7451 125.425 66.7526 118.193 54.2786 105.718C41.8047 93.2439 34.5723 80.2509 38.1283 76.6947C41.6843 73.1386 54.6768 80.3713 67.1508 92.8457C79.6247 105.32 86.8571 118.313 83.3011 121.869Z",
    fill: "url(#paint7_linear_29716_8594)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.871 106.758C127.486 106.645 127.145 106.382 126.658 105.547C126.336 105.81 126.128 106.131 125.977 106.633C126.425 107.204 126.741 107.505 127.372 107.825C127.416 107.398 127.555 107.166 127.864 106.758H127.871Z",
    fill: "url(#paint8_linear_29716_8594)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.791 105.196C142.164 105.529 142.41 105.911 142.454 106.589C144.02 106.018 144.942 105.466 146.249 104.562C146.059 103.614 145.731 103.15 145.466 102.836C144.317 104.085 143.344 104.587 141.791 105.196Z",
    fill: "url(#paint9_linear_29716_8594)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9066 91.0765C93.774 91.2711 93.7803 91.4594 93.7993 91.767C94.4686 91.6979 95.201 91.8234 96.0344 92.0431C96.0344 91.7983 96.0849 91.6414 96.2302 91.4155C95.3651 91.1268 94.8537 91.0452 93.9066 91.0828V91.0765Z",
    fill: "url(#paint10_linear_29716_8594)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M124.029 116.119C124.326 115.642 124.623 115.416 125.292 115.341C124.881 114.726 124.471 114.419 123.682 113.91C123.158 113.985 122.93 114.186 122.621 114.688C123.29 115.134 123.745 115.498 124.029 116.119Z",
    fill: "url(#paint11_linear_29716_8594)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.154 67.2089C137.611 66.9579 137.346 66.7947 137.049 66.3867C136.891 66.5625 136.771 66.6503 136.613 66.6629C136.904 67.1273 137.207 67.3658 137.762 67.6859C137.946 67.5604 138.065 67.4035 138.154 67.2089Z",
    fill: "url(#paint12_linear_29716_8594)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.635 74.1012C118.676 73.8564 118.139 73.6304 117.305 73.0781C117.028 73.4798 116.857 73.8689 116.863 74.3271C117.388 74.7539 118.133 75.1305 119.181 75.5322C119.105 74.823 119.181 74.4464 119.629 74.1075L119.635 74.1012Z",
    fill: "url(#paint13_linear_29716_8594)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.225 30.2769C111.875 30.6409 112.513 30.5844 113.485 30.2455C113.126 28.6701 113.094 27.7035 113.365 26.1909C112.646 26.398 112.09 26.3102 111.042 25.9336C110.783 27.4776 110.884 28.7015 111.231 30.2831L111.225 30.2769Z",
    fill: "url(#paint14_linear_29716_8594)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.182 66.2529C146.346 65.6127 146.365 65.2486 146.037 64.621C144.932 64.6022 144.281 64.508 143.227 64.2695C143.278 64.6587 143.227 64.9411 143.139 65.1733C144.357 65.4118 145.077 65.7131 146.182 66.2529Z",
    fill: "url(#paint15_linear_29716_8594)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2836 14.9492C33.6333 15.1061 33.2986 15.2693 32.8945 15.853C33.3996 16.8384 33.6333 17.4598 33.9174 18.5017C34.2457 18.2694 34.5172 18.1816 34.7635 18.1502C34.3972 16.9639 34.3215 16.1857 34.2836 14.9492Z",
    fill: "url(#paint16_linear_29716_8594)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3495 58.043C57.6234 59.769 57.3646 60.9176 57.2383 62.4804C58.4948 62.4992 59.284 62.2921 59.9785 61.9218C59.8333 60.9615 60.1048 60.2523 60.6162 59.1915C59.5366 59.0974 59.0125 58.7773 58.3559 58.043H58.3495Z",
    fill: "url(#paint17_linear_29716_8594)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6283 62.3544C24.5209 63.8921 24.5904 65.1349 25.1586 66.2834C26.1815 66.4152 26.8445 66.2897 27.5516 65.9194C26.9771 64.4696 26.8697 63.572 27.0654 62.0469C26.1247 62.549 25.4996 62.6996 24.6346 62.3544H24.6283Z",
    fill: "url(#paint18_linear_29716_8594)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5773 69.1676C82.7604 68.9856 82.9624 68.8726 83.2529 68.7533C82.7667 68.314 82.4699 68.0002 82.1984 67.5859C81.8575 67.6236 81.6996 67.7303 81.5039 67.9123C81.687 68.2261 82.0785 68.6906 82.5773 69.1676Z",
    fill: "url(#paint19_linear_29716_8594)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.689 39.3266C127.95 40.0547 126.908 40.4814 124.383 40.5254C124.579 41.5986 125.046 42.4711 126.005 43.4376C127.881 43.1426 128.973 42.8163 130.501 41.7869C129.579 41.1467 129.226 40.5442 128.695 39.3203L128.689 39.3266Z",
    fill: "url(#paint20_linear_29716_8594)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.432 120.751C110.874 120.927 111.095 121.04 111.347 121.353C111.461 121.203 111.556 121.127 111.682 121.115C111.429 120.757 111.177 120.581 110.722 120.355C110.583 120.468 110.495 120.594 110.432 120.751Z",
    fill: "url(#paint21_linear_29716_8594)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8813 79.671C49.755 80.1668 49.9066 80.5748 50.3044 81.1585C51.2956 80.6375 51.9333 80.443 52.9941 80.3551C52.7226 79.9157 52.6847 79.5329 52.7542 78.7734C51.6745 78.8801 50.8789 79.1688 49.8813 79.6772V79.671Z",
    fill: "url(#paint22_linear_29716_8594)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6992 90.5863C78.8231 90.5925 79.4355 90.4733 80.3448 89.6825C79.9343 87.8686 79.8144 86.7639 79.7828 84.9375C79.1577 85.1823 78.6652 85.2137 78.2548 85.1635C78.3559 87.2535 78.1538 88.5464 77.7055 90.58L77.6992 90.5863Z",
    fill: "url(#paint23_linear_29716_8594)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.455 12.4027C106.579 12.4089 107.191 12.2897 108.101 11.4989C107.69 9.68498 107.57 8.58034 107.539 6.75391C106.914 6.99869 106.421 7.03007 106.011 6.97986C106.112 9.0699 105.91 10.3628 105.461 12.3964L105.455 12.4027Z",
    fill: "url(#paint24_linear_29716_8594)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M122.325 82.3723C121.466 81.3994 120.892 80.9726 119.509 80.7969C118.253 82.548 117.381 83.4957 115.828 84.9267C116.523 85.2782 116.927 85.6674 117.198 86.0628C118.928 84.3681 120.21 83.5522 122.325 82.3723Z",
    fill: "url(#paint25_linear_29716_8594)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1118 48.9883C70.2531 49.1452 69.3313 49.3962 68.6305 50.118C68.5926 50.8461 68.5231 51.3357 68.2832 52.0512C68.8767 51.7876 69.3061 51.9194 70.0637 52.4403C70.1458 51.3357 70.5499 50.3377 71.1182 48.9883H71.1118Z",
    fill: "url(#paint26_linear_29716_8594)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.986 97.0479C105.207 97.481 105.548 97.6567 106.117 97.9266C106.66 96.6713 107.607 95.5039 108.838 94.2486C108.39 94.0101 108.175 93.7591 107.903 93.2695C106.527 94.5185 105.864 95.3345 104.986 97.0479Z",
    fill: "url(#paint27_linear_29716_8594)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.254 74.847C158.507 75.0667 158.772 75.0918 159.208 75.1169C159.227 74.1692 159.536 73.1712 159.997 72.0415C159.65 72.0038 159.441 71.8971 159.138 71.6523C158.576 72.8135 158.368 73.5102 158.248 74.8408L158.254 74.847Z",
    fill: "url(#paint28_linear_29716_8594)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.078 89.6966C129.255 89.2447 129.533 88.8995 130.139 88.6359C129.097 87.3995 128.276 86.7467 127.013 85.8555C126.205 86.345 125.883 86.7969 125.688 87.1421C127.222 87.7698 128.005 88.4916 129.078 89.6966Z",
    fill: "url(#paint29_linear_29716_8594)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4492 76.4082C65.525 76.8601 65.7081 77.1111 66.1501 77.3497C66.5984 77.1676 66.8951 76.9731 67.0845 76.6592C66.8572 76.2011 66.8383 75.8308 66.8635 75.2031C66.3963 75.7366 66.0932 76.0567 65.4492 76.4082Z",
    fill: "url(#paint30_linear_29716_8594)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6519 91.5479C60.4688 90.9516 60.1721 90.6378 59.5344 90.3867C58.9598 90.7131 58.5873 91.0269 58.3789 91.4851C58.7704 92.0751 58.8588 92.5709 58.9345 93.437C59.4775 92.6274 59.8374 92.1441 60.6519 91.5479Z",
    fill: "url(#paint31_linear_29716_8594)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9091 76.6108C84.1427 76.0397 84.2311 75.6631 84.269 75.1484C83.8586 75.1484 83.5997 75.2112 83.3661 75.3367C83.4166 75.6505 83.3282 75.889 83.1641 76.2343C83.5176 76.2656 83.6944 76.3661 83.9091 76.6108Z",
    fill: "url(#paint32_linear_29716_8594)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0731 14.7605C57.5972 13.4864 57.7866 12.6454 57.875 11.4968C56.9532 11.4842 56.3723 11.6412 55.8608 11.9173C55.9682 12.6265 55.7725 13.1412 55.4062 13.9258C56.2018 13.9948 56.587 14.227 57.0731 14.7605Z",
    fill: "url(#paint33_linear_29716_8594)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4194 108.059C93.0154 108.36 92.706 108.41 92.2324 108.416C92.5923 109.151 93.0406 109.841 93.3374 110.08C93.6973 109.916 93.9624 109.703 94.2845 109.352C93.9498 109.088 93.7415 108.705 93.4258 108.059H93.4194Z",
    fill: "url(#paint34_linear_29716_8594)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0397 18.4648C88.7682 19.5569 88.6672 20.4607 88.9323 21.3583C89.6521 21.5779 90.1446 21.5717 90.6939 21.3896C90.4603 20.2787 90.4919 19.6197 90.8202 18.5402C90.0815 18.7849 89.6143 18.8163 89.0334 18.4648H89.0397Z",
    fill: "url(#paint35_linear_29716_8594)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.346 86.3945C100.34 86.9971 100.302 87.3046 100.043 87.7502C100.277 87.8193 100.409 87.8946 100.479 88.0327C100.788 87.5745 100.883 87.1916 100.946 86.5577C100.75 86.4447 100.554 86.4008 100.34 86.3945H100.346Z",
    fill: "url(#paint36_linear_29716_8594)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.951 47.7706C112.292 47.6513 112.62 47.6325 113.069 47.8396C113.258 46.6597 113.226 45.8814 113.106 44.7454C112.437 44.532 112.027 44.5759 111.736 44.6324C112.128 45.7935 112.109 46.5781 111.951 47.7643V47.7706Z",
    fill: "url(#paint37_linear_29716_8594)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9185 28.7188C63.546 28.8317 63.1482 28.9886 62.8767 29.3464C62.8956 29.6728 62.8956 29.8924 62.8262 30.2188C63.0724 30.0682 63.2681 30.1058 63.6344 30.3004C63.6091 29.8046 63.7417 29.3464 63.9185 28.7188Z",
    fill: "url(#paint38_linear_29716_8594)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5179 0.169463C66.7791 0.533494 65.8825 0.596258 63.9631 0C63.8431 0.859867 63.9631 1.63186 64.4493 2.60471C65.9394 2.85576 66.8423 2.88087 68.2566 2.48545C67.7262 1.76994 67.6062 1.23017 67.5179 0.175739V0.169463Z",
    fill: "url(#paint39_linear_29716_8594)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1012 62.4062C42.1266 61.9292 42.1645 61.6907 42.3861 61.3518C42.2089 61.289 42.1012 61.2263 42.0506 61.1133C41.7911 61.4648 41.7024 61.7597 41.6328 62.2619C41.7847 62.356 41.9367 62.3999 42.1012 62.4062Z",
    fill: "url(#paint40_linear_29716_8594)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3849 52.5554C47.6817 52.6119 47.8964 52.5114 48.2436 52.3294C47.8206 51.5888 47.5996 50.6787 47.4355 49.6055C47.1513 49.7373 46.943 49.7498 46.5957 49.6933C46.6967 50.8419 46.8546 51.4758 47.3786 52.5554H47.3849Z",
    fill: "url(#paint41_linear_29716_8594)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9258 74.5549C33.1847 74.8373 33.4877 75.1135 33.9171 75.2076C34.1949 75.057 34.3969 74.9628 34.7189 74.8875C34.4853 74.7306 34.4348 74.5423 34.4538 74.1406C34.0244 74.3666 33.5572 74.4482 32.9258 74.5486V74.5549Z",
    fill: "url(#paint42_linear_29716_8594)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8862 35.5424C77.0022 35.26 76.4845 35.2097 75.5753 35.6114C75.4553 37.1429 75.2785 38.0467 74.8555 39.4965C75.4111 39.4589 75.8089 39.5467 76.1183 39.6911C76.5476 38.0153 77.0275 37.0424 77.8862 35.5424Z",
    fill: "url(#paint43_linear_29716_8594)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4194 67.2578C46.7249 67.967 46.245 68.6072 46.043 69.4106C46.4913 69.8939 46.8701 70.1073 47.3689 70.214C47.6909 69.2663 48.0066 68.7767 48.739 68.1051C48.0697 67.967 47.6972 67.785 47.4131 67.2578H47.4194Z",
    fill: "url(#paint44_linear_29716_8594)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3193 78.7864C96.2664 78.2153 96.7399 77.7194 97.3019 76.6022C96.0138 76.0939 95.3572 75.5604 94.7952 74.7695C93.8671 75.2403 93.3178 75.711 92.5664 76.5395C93.6777 77.1295 94.3596 77.7383 95.313 78.7864H95.3193Z",
    fill: "url(#paint45_linear_29716_8594)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.809 91.7171C68.4594 91.328 68.8193 91.0141 69.236 90.5371C68.8319 90.2296 68.5225 90.1103 68.2068 90.0664C68.0237 90.4116 67.7648 90.5811 67.3418 90.807C67.6701 91.0957 67.7648 91.3217 67.8027 91.7171H67.809Z",
    fill: "url(#paint46_linear_29716_8594)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2542 104.884C36.5636 104.985 36.7657 104.991 37.1255 104.897C36.9866 104.514 36.9803 104.263 37.0498 103.987C36.7657 103.874 36.551 103.842 36.2227 103.836C36.3047 104.194 36.3047 104.464 36.2542 104.878V104.884Z",
    fill: "url(#paint47_linear_29716_8594)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.082 51.6127C84.3851 52.4286 84.3156 52.9747 84.082 53.7655C85.49 53.527 86.8791 53.1316 87.4284 52.7613C87.34 52.0834 87.1064 51.5374 86.6834 50.8281C86.0646 51.2549 85.3322 51.4056 84.082 51.6064V51.6127Z",
    fill: "url(#paint48_linear_29716_8594)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.104 43.9299C55.9398 44.8463 56.1166 45.4614 56.8048 46.2208C57.7898 46.1769 58.497 46.0074 59.0842 45.5304C58.9642 44.4885 59.1789 43.7667 59.665 42.5742C58.3959 43.2835 57.5877 43.6851 56.104 43.9299Z",
    fill: "url(#paint49_linear_29716_8594)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5517 49.5456C30.4697 48.0079 30.5265 47.2171 31.1074 46.0434C30.5075 45.9053 30.1603 45.7296 29.9519 45.3906C29.2384 46.6145 29.0553 47.5874 28.9922 49.2255C29.5099 49.4828 30.0087 49.5644 30.558 49.5393L30.5517 49.5456Z",
    fill: "url(#paint50_linear_29716_8594)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1348 3.11356C80.4189 3.38345 80.5957 3.69727 80.6083 4.22448C81.8585 3.82907 82.5972 3.42111 83.6516 2.75581C83.5317 2.00892 83.2917 1.62606 83.096 1.375C82.1552 2.31646 81.3723 2.68049 80.1348 3.10729V3.11356Z",
    fill: "url(#paint51_linear_29716_8594)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8008 104.427C77.3185 105.105 77.5585 105.99 77.3248 108.042C78.2214 107.998 78.9917 107.716 79.882 107.044C79.8441 105.494 79.6926 104.578 79.0107 103.234C78.3856 103.912 77.8552 104.138 76.8008 104.433V104.427Z",
    fill: "url(#paint52_linear_29716_8594)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4306 86.4595C90.5505 85.8445 90.5442 85.4993 90.2033 84.9218C89.1552 84.9658 88.5301 84.9156 87.5199 84.7461C87.5893 85.1164 87.5577 85.3863 87.4883 85.606C88.6564 85.7629 89.3509 86.0076 90.4306 86.4595Z",
    fill: "url(#paint53_linear_29716_8594)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M101.812 67.1079C101.622 66.6811 101.439 66.4551 100.997 66.1602C100.713 66.6748 100.448 66.9196 100.088 67.1079C100.239 67.5221 100.41 67.7732 100.719 68.1372C101.029 67.7041 101.325 67.4531 101.818 67.1079H101.812Z",
    fill: "url(#paint54_linear_29716_8594)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.324 99.2227C121.781 99.6432 121.535 99.9382 121.402 100.66C122.299 101.375 122.779 101.859 123.499 102.725C123.707 102.367 123.928 102.166 124.149 102.034C123.297 101.068 122.899 100.371 122.33 99.2227H122.324Z",
    fill: "url(#paint55_linear_29716_8594)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.405 75.787C133.784 75.1782 134.144 74.4878 134.087 73.6593C133.664 73.2325 133.399 72.9187 133.102 72.3789C132.938 72.881 132.616 73.0693 131.877 73.2388C132.508 73.8978 132.893 74.6949 133.405 75.7807V75.787Z",
    fill: "url(#paint56_linear_29716_8594)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8087 41.0028C98.8742 40.438 98.2996 40.2371 97.1505 40.4505C96.5886 42.1702 96.134 43.1494 95.25 44.6871C95.894 44.7938 96.3171 45.0072 96.6391 45.252C97.5988 43.4569 98.4133 42.4778 99.8087 40.9966V41.0028Z",
    fill: "url(#paint57_linear_29716_8594)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8047 29.2489C94.5497 29.4623 95.3832 29.6192 96.2292 29.3179C96.5449 28.753 96.7975 28.389 97.271 27.9183C96.6965 27.8995 96.406 27.6233 96.0019 26.9141C95.5031 27.7614 94.7833 28.4016 93.8047 29.2489Z",
    fill: "url(#paint58_linear_29716_8594)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0772 78.5152C62.3297 77.8248 62.4118 77.3729 62.4308 76.7578C61.9383 76.7704 61.6352 76.8708 61.37 77.0277C61.4458 77.4043 61.3511 77.6804 61.168 78.1072C61.591 78.1261 61.8057 78.239 62.0772 78.5152Z",
    fill: "url(#paint59_linear_29716_8594)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M116.702 97.8555C115.414 98.0877 114.644 98.3701 113.678 98.8848C114.139 99.6191 114.562 99.9957 115.042 100.266C115.553 99.82 116.071 99.707 116.885 99.6066C116.538 98.9476 116.525 98.5208 116.708 97.8617L116.702 97.8555Z",
    fill: "url(#paint60_linear_29716_8594)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1602 25.5535C34.7814 25.3589 34.4973 25.089 34.3205 24.543C33.1461 25.3401 32.502 25.9928 31.6055 27.0096C31.9654 27.7502 32.3316 28.0703 32.6157 28.2712C33.3039 26.997 34.0048 26.382 35.1539 25.5535H35.1602Z",
    fill: "url(#paint61_linear_29716_8594)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 65.1484C69.4486 65.456 69.4171 65.707 69.5433 66.0962C69.9096 66.2405 70.1937 66.2907 70.4841 66.2091C70.6104 65.8075 70.8061 65.5815 71.1787 65.2238C70.5978 65.2802 70.2379 65.2991 69.657 65.1484Z",
    fill: "url(#paint62_linear_29716_8594)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3364 77.8008C28.4942 78.4347 28.7215 79.1126 29.3024 79.6021C29.8517 79.6021 30.2243 79.6272 30.7736 79.7778C30.5463 79.3511 30.6284 79.0247 30.9819 78.4347C30.1422 78.4221 29.3719 78.1648 28.3301 77.8071L28.3364 77.8008Z",
    fill: "url(#paint63_linear_29716_8594)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4375 65.7366C99.4375 66.2325 99.5259 66.5274 99.829 66.9982C100.321 66.6216 100.681 66.4961 101.117 66.4647C101.149 66.0002 101.092 65.6864 100.947 65.2031C100.46 65.4918 100.069 65.6111 99.4438 65.7366H99.4375Z",
    fill: "url(#paint64_linear_29716_8594)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M114.364 96.8079L112.533 97.605C112.533 97.605 110.437 94.7681 108.246 94.5861C107.886 94.5547 107.526 94.5986 107.166 94.7304L108.997 93.9333C111.529 92.9668 114.364 96.8079 114.364 96.8079Z",
    fill: "url(#paint65_linear_29716_8594)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4862 114.425C82.1957 114.538 81.88 114.6 81.5391 114.625C83.8121 112.335 84.1404 105.368 88.8127 103.146C88.8759 103.114 88.939 103.083 89.0085 103.058C89.0527 103.039 89.0969 103.02 89.1411 103.001C89.3557 102.92 89.5767 102.863 89.7977 102.832C85.5232 105.719 85.4474 113.006 82.6566 114.355C82.5998 114.381 82.5493 114.406 82.4925 114.431L82.4862 114.425Z",
    fill: "url(#paint66_linear_29716_8594)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M103.441 106.437C103.088 106.588 102.734 106.682 102.387 106.714C105.058 104.184 104.843 95.8555 107.072 94.7822C107.072 94.7822 107.128 94.7571 107.16 94.7446C107.514 94.6065 107.88 94.5688 108.24 94.6002C106.529 97.0731 106.585 105.069 103.441 106.444V106.437Z",
    fill: "url(#paint67_linear_29716_8594)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4855 114.426L80.6608 115.223C77.5922 116.441 71.1899 112.004 67.9824 113.334L69.8135 112.537C72.7242 111.332 78.2426 114.853 81.5384 114.627C81.8794 114.602 82.2014 114.539 82.4855 114.426Z",
    fill: "url(#paint68_linear_29716_8594)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.442 106.435L101.611 107.232C97.6013 108.983 93.5667 102.292 89.7973 102.832C89.5763 102.864 89.3616 102.92 89.1406 103.002L90.9717 102.205C94.5959 100.818 98.4916 107.088 102.381 106.711C102.735 106.68 103.088 106.592 103.435 106.435H103.442Z",
    fill: "url(#paint69_linear_29716_8594)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7143 34.6626C69.42 36.9347 63.4659 36.0685 61.4707 38.1209L62.0958 36.7213C63.9331 34.8258 69.1548 35.4158 70.9669 33.7274C71.0995 33.6082 71.2068 33.4764 71.3015 33.332L70.8722 34.3111L70.7143 34.6626Z",
    fill: "url(#paint70_linear_29716_8594)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6121 29.3636C69.3935 29.4075 67.9792 29.0874 66.7606 28.3782C66.1671 28.033 65.9587 27.7568 66.0092 27.5685C66.1797 26.966 69.0526 27.3049 70.6121 29.3636Z",
    fill: "url(#paint71_linear_29716_8594)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.151 24.6266C71.0714 24.5576 69.9664 24.2626 69.1267 23.7354C68.7352 23.4906 68.6026 23.3148 68.6468 23.2144C68.792 22.9006 70.7367 23.3399 72.151 24.6266Z",
    fill: "url(#paint72_linear_29716_8594)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4104 27.9639L73.3788 28.0393C73.3283 28.1522 73.2589 28.2527 73.1831 28.3468C73.1073 28.4472 73.0189 28.5351 72.9179 28.623C72.9179 28.3907 72.8674 28.1334 72.7727 27.8635C72.5201 27.1292 72.0655 26.5204 71.5352 26.0308C72.1034 26.0685 72.6717 26.0371 73.1831 25.9492C73.2652 26.1124 73.3409 26.2819 73.4041 26.4639C73.5304 26.8405 73.5746 27.1794 73.543 27.4869C73.5241 27.6627 73.4798 27.8196 73.4167 27.9702L73.4104 27.9639Z",
    fill: "url(#paint73_linear_29716_8594)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9355 23.2893C75.8282 23.5403 75.6451 23.7474 75.4052 23.9295C75.3483 23.5403 75.1337 23.0947 74.7422 22.5989L75.3673 21.1992C76.0492 22.0528 76.1754 22.7495 75.9418 23.2893H75.9355Z",
    fill: "url(#paint74_linear_29716_8594)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3011 33.3328C71.2064 33.4771 71.0991 33.6089 70.9665 33.7282C70.9665 33.6529 70.9665 33.5775 70.9665 33.4959C70.9033 32.3662 70.5245 31.4624 69.9941 30.7594C70.4551 30.7406 70.8907 30.6778 71.2759 30.5586C71.4463 31.0168 71.56 31.5252 71.5916 32.0963C71.6042 32.3662 71.5853 32.611 71.5221 32.8307C71.4716 33.0127 71.3958 33.1821 71.3011 33.3328Z",
    fill: "url(#paint75_linear_29716_8594)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9332 23.2964L75.3081 24.6961C75.0176 25.3488 74.1968 25.7693 73.174 25.9451C72.6626 26.0329 72.0943 26.0643 71.526 26.0267C70.4464 25.9576 69.3414 25.6626 68.5017 25.1354C68.1102 24.8906 67.9776 24.7149 68.0218 24.6145L68.6469 23.2148C68.6027 23.3153 68.7353 23.491 69.1267 23.7358C69.9665 24.2693 71.0714 24.5643 72.1511 24.627C73.4329 24.7086 74.6767 24.4701 75.4028 23.9304C75.6427 23.7546 75.8258 23.5412 75.9332 23.2964Z",
    fill: "url(#paint76_linear_29716_8594)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3753 28.0395L72.7439 29.458C72.485 29.9789 71.9546 30.3492 71.2727 30.5563C70.8876 30.6756 70.4519 30.7446 69.991 30.7572C68.7724 30.8011 67.3581 30.481 66.1395 29.7718C65.546 29.4266 65.3376 29.1504 65.3881 28.9621L66.0132 27.5625C65.9627 27.7508 66.1711 28.027 66.7646 28.3722C67.9769 29.0751 69.3912 29.4015 70.6161 29.3576C71.5569 29.3262 72.384 29.0751 72.9207 28.6169C73.0217 28.5353 73.1101 28.4412 73.1859 28.3408C73.2616 28.2466 73.3248 28.1399 73.3816 28.0332L73.3753 28.0395Z",
    fill: "url(#paint77_linear_29716_8594)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M140.216 95.2551C137.64 95.776 134.382 90.7486 131.516 90.6042L132.987 90.1523C135.632 90.2841 138.619 94.5835 141.088 94.8283C141.264 94.8471 141.435 94.8408 141.605 94.8157L140.582 95.1358L140.21 95.2551H140.216Z",
    fill: "url(#paint78_linear_29716_8594)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M144.168 91.6912C143.334 90.8062 142.646 89.5321 142.381 88.1638C142.255 87.4923 142.324 87.1533 142.501 87.0718C143.069 86.8019 144.698 89.1806 144.168 91.6975V91.6912Z",
    fill: "url(#paint79_linear_29716_8594)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M148.772 89.7323C148.115 88.8788 147.61 87.8557 147.465 86.8829C147.396 86.431 147.44 86.2176 147.547 86.1799C147.882 86.0795 148.829 87.8306 148.778 89.7323H148.772Z",
    fill: "url(#paint80_linear_29716_8594)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.067 92.8636L146.985 92.8887C146.865 92.9201 146.745 92.9389 146.625 92.9452C146.499 92.9515 146.372 92.9452 146.246 92.9264C146.423 92.7695 146.581 92.5623 146.726 92.3176C147.117 91.646 147.282 90.9054 147.301 90.1836C147.648 90.6355 148.039 91.0372 148.443 91.3636C148.374 91.533 148.292 91.7025 148.197 91.8657C147.995 92.2109 147.768 92.4619 147.515 92.6377C147.37 92.7381 147.225 92.8134 147.067 92.8636Z",
    fill: "url(#paint81_linear_29716_8594)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M152.269 91.6919H152.263C152.004 91.7735 151.726 91.7735 151.436 91.7108C151.694 91.4095 151.89 90.9639 152.004 90.3425L153.475 89.8906C153.279 90.9639 152.831 91.5162 152.269 91.6919Z",
    fill: "url(#paint82_linear_29716_8594)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M141.61 94.8144C141.439 94.8395 141.262 94.8458 141.092 94.8269C141.149 94.7767 141.205 94.7265 141.262 94.67C142.077 93.8792 142.512 93.0005 142.696 92.1406C143.011 92.4796 143.352 92.7557 143.693 92.9691C143.46 93.3959 143.144 93.8164 142.733 94.2181C142.538 94.4064 142.336 94.5508 142.134 94.6449C141.963 94.7265 141.786 94.783 141.61 94.8081V94.8144Z",
    fill: "url(#paint83_linear_29716_8594)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M152.264 91.6904L150.793 92.1423C150.111 92.3557 149.246 92.0167 148.444 91.364C148.04 91.0376 147.649 90.6359 147.301 90.184C146.645 89.3304 146.14 88.3074 145.994 87.3345C145.925 86.8826 145.969 86.663 146.076 86.6316L147.548 86.1797C147.44 86.2111 147.396 86.4307 147.466 86.8826C147.617 87.8618 148.116 88.8785 148.773 89.7321C149.555 90.7426 150.553 91.5209 151.437 91.7092C151.727 91.772 152.012 91.772 152.264 91.6904Z",
    fill: "url(#paint84_linear_29716_8594)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M146.987 92.8885L145.49 93.3467C144.922 93.4911 144.297 93.3404 143.691 92.9701C143.343 92.7567 143.009 92.4806 142.693 92.1416C141.86 91.2567 141.171 89.9826 140.906 88.6143C140.78 87.9427 140.849 87.6038 141.026 87.5222L142.497 87.0703C142.321 87.1519 142.251 87.4908 142.377 88.1624C142.643 89.5369 143.324 90.8048 144.164 91.6897C144.808 92.3739 145.541 92.8321 146.235 92.9325C146.361 92.9513 146.488 92.9576 146.614 92.9513C146.734 92.9513 146.86 92.9262 146.974 92.8948L146.987 92.8885Z",
    fill: "url(#paint85_linear_29716_8594)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M133.787 79.7699L130.447 80.7678C130.933 80.5921 131.375 80.3473 131.773 80.0335C134.577 77.8744 135.618 72.8093 138.308 70.4745L141.648 69.4766C138.573 72.144 137.651 78.389 133.787 79.7699Z",
    fill: "url(#paint86_linear_29716_8594)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M129.993 80.8982C129.721 80.9673 129.437 81.0112 129.134 81.0238C126.539 81.1807 122.915 79.4609 120.465 78.7015C117.858 77.8918 115.25 77.4462 112.585 77.6157C112.055 77.6471 111.531 77.7098 111.02 77.7977C111.55 77.5655 112.093 77.3646 112.655 77.1952H112.68C113.716 76.8813 114.802 76.6868 115.932 76.6177C118.596 76.4483 121.204 76.8939 123.812 77.7036C126.053 78.4002 129.267 79.8877 131.78 80.0258C131.376 80.3396 130.94 80.5844 130.454 80.7602C130.309 80.8104 130.157 80.8606 129.999 80.8982H129.993Z",
    fill: "url(#paint87_linear_29716_8594)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3354 95.1233C88.0537 95.4623 86.7593 95.4748 85.4902 95.0292L88.8303 94.0312C89.6511 94.32 90.4782 94.4141 91.3117 94.3514C90.8318 94.5961 90.352 94.797 89.8595 94.9602C89.6827 95.0166 89.5122 95.0731 89.3354 95.1171V95.1233Z",
    fill: "url(#paint88_linear_29716_8594)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M92.963 94.0412H92.9503L89.8691 94.9575C90.3553 94.7943 90.8415 94.5872 91.3213 94.3487C95.5706 92.1959 99.4095 87.1309 101.266 84.3065C103.236 81.3126 106.02 79.1787 109.316 78.1933L112.656 77.1953C112.094 77.3648 111.551 77.5656 111.021 77.7978C108.438 78.9339 106.241 80.8231 104.606 83.3085C102.503 86.5032 97.8626 92.5725 92.963 94.0349V94.0412Z",
    fill: "url(#paint89_linear_29716_8594)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M103.815 46.5614L102.218 48.1493C102.401 47.9359 102.546 47.7162 102.666 47.4777C103.626 45.5948 102.723 42.9775 101.416 40.4419L103.02 38.8477C104.491 41.6971 105.451 44.6533 103.822 46.5551L103.815 46.5614Z",
    fill: "url(#paint90_linear_29716_8594)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9043 57.3294C87.9738 57.0658 88.0874 56.8398 88.2642 56.6264C88.5041 56.3377 88.8514 56.0804 89.3565 55.8042C90.8024 55.0636 92.5577 55.3272 93.8331 54.9883C93.7257 55.39 93.5679 55.6912 93.3595 55.9297C92.2483 57.2039 89.8364 56.4381 87.9043 57.3294Z",
    fill: "url(#paint91_linear_29716_8594)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7131 49.6435C98.3745 50.0765 96.7582 50.0263 95.4512 50.428C95.4575 50.1079 95.5333 49.838 95.7606 49.5807C95.8111 49.5179 95.8742 49.4614 95.9437 49.3987C96.1015 49.2669 96.3036 49.1413 96.5624 49.0095C97.901 48.3505 99.8015 48.5388 101.311 48.0493C101.828 47.8923 102.277 47.6978 102.668 47.4844C102.548 47.7166 102.403 47.9426 102.22 48.1559C101.689 48.7773 100.875 49.292 99.7131 49.6435Z",
    fill: "url(#paint92_linear_29716_8594)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9627 54.3443L93.3652 55.9322C93.5673 55.7 93.7314 55.3924 93.8388 54.9907C93.9145 54.6958 93.9651 54.3443 93.9777 53.93C93.9903 52.6057 93.542 51.7898 94.1292 51.1433L94.2681 51.0115L95.7582 49.5742C95.5309 49.8316 95.4552 50.1077 95.4488 50.4215C95.4362 50.9174 95.5877 51.5262 95.5751 52.3421C95.5499 53.3087 95.3289 53.93 94.969 54.3443H94.9627Z",
    fill: "url(#paint93_linear_29716_8594)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6526 63.4717L86.0488 65.0659C87.0906 62.888 86.3708 62.4173 86.2256 60.4841C86.1562 59.1849 86.2509 58.5071 87.0149 57.8857L88.265 56.6367C88.0882 56.8501 87.9746 57.0761 87.9051 57.3397C87.7915 57.7476 87.7852 58.2435 87.823 58.8962C87.9746 60.8356 88.6881 61.3001 87.6463 63.478L87.6526 63.4717Z",
    fill: "url(#paint94_linear_29716_8594)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M157.969 46.0194L155.752 47.1806C153.656 45.2098 147.576 40.6782 143.636 41.2117C143.194 41.2745 142.777 41.3937 142.398 41.5946L144.615 40.4334C148.378 38.4564 155.632 43.8227 157.969 46.0131V46.0194Z",
    fill: "url(#paint95_linear_29716_8594)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M112.211 68.1895L109.995 69.3507C109.445 65.6037 110.5 63.432 112.419 62.5094C112.76 62.3462 113.12 62.2207 113.505 62.1328C112.325 63.2939 111.775 65.2585 112.205 68.1895H112.211Z",
    fill: "url(#paint96_linear_29716_8594)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M140.939 55.9165L140.908 55.9354C140.542 56.1237 140.137 56.1864 139.721 56.155C142.732 52.2072 138.742 45.3157 141.501 42.2842C141.773 41.9955 142.069 41.7695 142.398 41.5938C142.777 41.3929 143.193 41.2674 143.635 41.2109C140.92 44.4182 145.258 51.6737 141.514 55.4772C141.331 55.6655 141.141 55.8098 140.946 55.9103L140.939 55.9165Z",
    fill: "url(#paint97_linear_29716_8594)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M126.543 63.405C126.221 63.5179 125.88 63.5179 125.514 63.4552C125.564 63.3736 125.608 63.2794 125.653 63.1853C126.675 60.9948 125.76 57.5616 126.783 55.3712C127.143 54.5741 127.572 54.072 128.052 53.7958L128.184 53.7268C128.551 53.551 128.942 53.5008 129.359 53.5322C129.233 53.7268 129.113 53.9527 128.993 54.2038C127.97 56.388 128.885 59.8274 127.862 62.0179C127.597 62.5639 127.307 62.928 126.985 63.1602C126.84 63.2669 126.688 63.3422 126.53 63.3987L126.543 63.405Z",
    fill: "url(#paint98_linear_29716_8594)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.049 62.7372C117.016 62.0154 115.083 61.7706 113.518 62.1221C113.132 62.21 112.766 62.3355 112.432 62.4987L114.2 61.5824L114.888 61.2246C116.574 60.5279 118.853 60.7099 121.271 61.5698C122.837 62.1661 124.296 63.2205 125.527 63.4464C125.887 63.5092 126.234 63.5092 126.556 63.3962L124.801 64.3189C123.329 65.3984 121.309 63.5845 119.061 62.7309L119.049 62.7372Z",
    fill: "url(#paint99_linear_29716_8594)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M140.907 55.9364L138.83 57.0222L138.59 57.1478C136.052 58.265 132.213 53.7899 129.372 53.5388C128.955 53.5012 128.563 53.5577 128.197 53.7334L130.275 52.6413C132.806 51.1915 136.791 55.9553 139.727 56.1561C140.143 56.1875 140.547 56.1247 140.914 55.9364H140.907Z",
    fill: "url(#paint100_linear_29716_8594)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6945 51.9414L78.0466 54.452C78.0466 54.452 74.9527 57.2199 68.5441 59.9438C68.5125 59.9564 68.4809 59.9752 68.4431 59.9877C67.8559 60.2388 67.4518 60.5401 67.1992 60.8915L68.7651 58.5128C69.005 58.1111 69.4344 57.7596 70.0973 57.4772C76.5691 54.7344 79.6945 51.9414 79.6945 51.9414Z",
    fill: "url(#paint101_linear_29716_8594)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2271 84.1719L58.6423 86.5757L58.5224 86.7577C57.8783 87.6302 56.6787 87.831 55.1191 88.1072L56.7671 85.5966C57.6447 85.446 58.415 85.3142 59.0275 85.0694C59.5389 84.8686 59.943 84.5987 60.2271 84.1719Z",
    fill: "url(#paint102_linear_29716_8594)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2249 84.167C59.9408 84.5875 59.5367 84.8637 59.0253 85.0645C59.0505 84.5122 59.0063 83.8532 58.8801 83.0435C58.5391 80.9095 57.3837 79.0831 58.5139 77.2881L58.5896 77.1751C58.8485 76.7922 59.2147 76.4156 59.7135 76.0391C59.5304 77.4387 60.2754 78.8948 60.5343 80.533C60.8248 82.3657 60.6922 83.4703 60.2312 84.1607L60.2249 84.167Z",
    fill: "url(#paint103_linear_29716_8594)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M71.872 68.3047L70.2935 70.7023L70.1483 70.9219C69.138 72.2839 66.4862 73.012 63.8091 73.9974C61.9149 74.6941 60.6016 75.3719 59.7176 76.0498C59.2188 76.4326 58.8526 76.8092 58.5938 77.1858L60.2543 74.6627C60.9804 73.6145 62.5084 72.5726 65.4633 71.4868C67.3449 70.7901 69.2201 70.2253 70.5145 69.4784C71.108 69.1332 71.5878 68.7503 71.8846 68.3047H71.872Z",
    fill: "url(#paint104_linear_29716_8594)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8822 68.2914V68.3039C71.5791 68.7558 71.0993 69.1387 70.5058 69.4776C70.0638 67.0863 65.764 63.2514 67.1152 61.017L67.2036 60.8852C67.4561 60.54 67.8602 60.2325 68.4474 59.9814C68.479 59.9689 68.5106 59.9563 68.5484 59.9375C68.9778 62.4794 72.722 65.9064 72.1348 67.7704C72.0779 67.9525 71.9959 68.1282 71.8885 68.2914H71.8822Z",
    fill: "url(#paint105_linear_29716_8594)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M149.611 118.839L145.949 119.015C145.949 119.015 140.999 117.967 133.719 113.643C133.681 113.624 133.643 113.599 133.605 113.574C132.936 113.172 132.349 112.996 131.818 113.002L135.291 112.833C135.866 112.783 136.516 112.946 137.267 113.398C144.61 117.779 149.611 118.839 149.611 118.839Z",
    fill: "url(#paint106_linear_29716_8594)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 122.818L100.253 122.981L99.9882 122.994C98.6686 122.994 97.6015 121.952 96.2188 120.621L99.8808 120.445C100.657 121.198 101.339 121.851 102.021 122.284C102.583 122.642 103.145 122.843 103.764 122.818H103.77Z",
    fill: "url(#paint107_linear_29716_8594)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 122.821C103.151 122.846 102.589 122.645 102.027 122.287C102.589 121.923 103.214 121.402 103.922 120.7C105.79 118.842 106.775 116.406 109.358 116.231H109.522C110.084 116.206 110.722 116.293 111.454 116.507C109.939 117.329 109.023 119.093 107.59 120.524C105.98 122.118 104.799 122.777 103.776 122.821H103.77Z",
    fill: "url(#paint108_linear_29716_8594)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M127.813 122.878L124.309 123.041L123.987 123.054C121.916 123.035 119.302 120.964 116.41 119.043C114.364 117.688 112.754 116.891 111.454 116.501C110.721 116.282 110.083 116.2 109.521 116.213L113.203 116.037C114.756 115.993 116.884 116.746 120.066 118.861C122.099 120.211 123.999 121.636 125.66 122.37C126.424 122.709 127.144 122.897 127.807 122.872L127.813 122.878Z",
    fill: "url(#paint109_linear_29716_8594)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 122.876H127.815C127.158 122.908 126.438 122.713 125.668 122.381C127.72 120.24 128.452 113.292 131.622 113.016H131.818C132.342 113.004 132.935 113.179 133.605 113.581C133.642 113.606 133.68 113.625 133.718 113.65C131.502 115.891 130.789 122.004 128.522 122.757C128.301 122.833 128.067 122.87 127.834 122.883V122.876Z",
    fill: "url(#paint110_linear_29716_8594)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.31 21.6172L40.1206 23.6884C40.089 24.0713 40.1585 24.4918 40.3542 24.9688C41.0109 26.6383 44.9129 27.2095 46.7313 28.7472C46.9523 28.9355 47.1291 29.1238 47.2553 29.3121C47.4953 29.6573 47.5837 29.9899 47.5521 30.3226L47.7415 28.2451C47.7857 27.7367 47.5458 27.2095 46.9144 26.676C45.096 25.1382 41.194 24.5734 40.5373 22.8976C40.5057 22.8285 40.4805 22.7532 40.4552 22.6842C40.3226 22.295 40.2784 21.9436 40.3037 21.6172H40.31Z",
    fill: "url(#paint111_linear_29716_8594)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1777 62.7742L37.9883 64.8454C38.6323 64.3119 38.9227 63.6717 38.9859 62.9688V62.9499C39.0175 62.5985 38.9859 62.2281 38.9227 61.8516C38.7586 62.1842 38.5187 62.498 38.184 62.7742H38.1777Z",
    fill: "url(#paint112_linear_29716_8594)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3203 21.5587V21.6152C40.2887 21.9416 40.3329 22.2931 40.4655 22.6822C41.5326 20.9876 44.7527 20.0712 46.047 17.8368L46.2365 15.7656C44.7211 18.3892 40.5665 19.1925 40.314 21.5587H40.3203Z",
    fill: "url(#paint113_linear_29716_8594)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6372 52.6914C36.6372 52.955 36.6561 53.25 36.7129 53.5638C37.5464 51.8692 40.1351 51.637 41.9093 50.1683C42.9006 49.3147 43.3868 48.4109 43.4941 47.5197C43.5004 47.4506 43.5067 47.3879 43.5131 47.3188C43.532 46.9987 43.5004 46.6849 43.431 46.3711C43.1784 46.9548 42.7491 47.5322 42.0987 48.0971C39.9773 49.8545 36.6814 49.8419 36.6309 52.6852L36.6372 52.6914Z",
    fill: "url(#paint114_linear_29716_8594)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M36.466 54.4229V54.4354C36.4219 54.8057 36.4408 55.2325 36.5355 55.7221C36.8259 57.3226 38.5307 59.7327 38.9159 61.8541C38.9853 62.2307 39.0106 62.601 38.979 62.9525L39.1684 60.8813C39.3641 58.5465 37.0596 55.5401 36.7186 53.6571C36.7186 53.632 36.706 53.6006 36.706 53.5755C36.6492 53.2554 36.6239 52.9667 36.6302 52.7031L36.4597 54.4291L36.466 54.4229Z",
    fill: "url(#paint115_linear_29716_8594)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4985 36.9609L36.3217 38.9066L36.3027 39.1326C36.3027 39.2016 36.3027 39.2644 36.3027 39.3271C36.4101 41.0845 38.6515 41.6871 39.9269 42.4779C41.657 43.388 43.0839 44.8127 43.4375 46.3818C43.5069 46.6956 43.5385 47.0095 43.5196 47.3296L43.709 45.2583C43.8226 43.3252 42.1873 41.4925 40.1164 40.4067C39.0304 39.7351 37.2435 39.1953 36.6689 37.9652C36.5679 37.7518 36.5048 37.5133 36.4921 37.2559C36.4921 37.1555 36.4921 37.0614 36.4921 36.9609H36.4985Z",
    fill: "url(#paint116_linear_29716_8594)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5046 36.9242V36.9619C36.492 37.056 36.492 37.1565 36.4983 37.2569C36.5172 37.5142 36.5741 37.7527 36.6751 37.9661C37.3949 36.7673 38.9986 35.8761 40.0467 35.374C42.5344 34.2066 47.3709 32.3738 47.5603 30.3152C47.5919 29.9825 47.5035 29.6436 47.2636 29.3047C45.9439 30.9303 42.2945 32.3425 40.2361 33.309C38.9102 33.9429 36.6814 35.2108 36.5046 36.9305V36.9242Z",
    fill: "url(#paint117_linear_29716_8594)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29716_8594",
    x1: 46.7214,
    y1: 146.953,
    x2: 16.1401,
    y2: 112.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EA3511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29716_8594",
    x1: 22.2692,
    y1: 168.59,
    x2: -3.32199,
    y2: 144.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29716_8594",
    x1: 29.0484,
    y1: 161.458,
    x2: 3.4507,
    y2: 137.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29716_8594",
    x1: 37.0043,
    y1: 153.097,
    x2: 11.4066,
    y2: 128.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29716_8594",
    x1: 60.8943,
    y1: 127.975,
    x2: 35.3032,
    y2: 103.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29716_8594",
    x1: 47.4685,
    y1: 142.093,
    x2: 21.8708,
    y2: 117.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFBD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29716_8594",
    x1: 52.2601,
    y1: 151.402,
    x2: 28.7775,
    y2: 128.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B89D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#564931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#18140D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_29716_8594",
    x1: 67.7774,
    y1: 92.3775,
    x2: 53.2727,
    y2: 106.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#AA1703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_29716_8594",
    x1: 66.7194,
    y1: 112.356,
    x2: 65.4703,
    y2: 113.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_29716_8594",
    x1: 152.628,
    y1: 108.98,
    x2: 153.916,
    y2: 111.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_29716_8594",
    x1: 90.8814,
    y1: 82.1621,
    x2: 90.5928,
    y2: 83.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_29716_8594",
    x1: 125.993,
    y1: 132.633,
    x2: 127.394,
    y2: 131.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_29716_8594",
    x1: 130.255,
    y1: 60.9294,
    x2: 130.887,
    y2: 60.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_29716_8594",
    x1: 97.9159,
    y1: 74.2323,
    x2: 97.1862,
    y2: 75.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_29716_8594",
    x1: 126.181,
    y1: 13.3624,
    x2: 122.725,
    y2: 13.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_29716_8594",
    x1: 128.036,
    y1: 36.8936,
    x2: 127.893,
    y2: 38.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_29716_8594",
    x1: 54.3815,
    y1: -7.57166,
    x2: 56.0698,
    y2: -8.30345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_29716_8594",
    x1: 65.5339,
    y1: 67.502,
    x2: 68.8396,
    y2: 68.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_29716_8594",
    x1: 5.44296,
    y1: 51.8647,
    x2: 8.2045,
    y2: 51.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_29716_8594",
    x1: 82.2904,
    y1: 79.9096,
    x2: 81.3137,
    y2: 80.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_29716_8594",
    x1: 123.484,
    y1: 51.5349,
    x2: 125.258,
    y2: 56.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_29716_8594",
    x1: 94.8575,
    y1: 102.921,
    x2: 94.3869,
    y2: 103.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_29716_8594",
    x1: 54.1907,
    y1: 82.0817,
    x2: 53.4705,
    y2: 79.8151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_29716_8594",
    x1: 87.4284,
    y1: 81.768,
    x2: 84.3814,
    y2: 82.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_29716_8594",
    x1: 115.173,
    y1: 3.62812,
    x2: 112.126,
    y2: 4.11629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_29716_8594",
    x1: 147.533,
    y1: 86.6758,
    x2: 150.275,
    y2: 88.9238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_29716_8594",
    x1: 36.351,
    y1: 53.9576,
    x2: 33.7565,
    y2: 53.5798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_29716_8594",
    x1: 94.5527,
    y1: 95.3955,
    x2: 96.2737,
    y2: 97.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_29716_8594",
    x1: 183.208,
    y1: 56.583,
    x2: 184.74,
    y2: 57.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_29716_8594",
    x1: 128.87,
    y1: 61.252,
    x2: 130.437,
    y2: 59.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_29716_8594",
    x1: 35.1591,
    y1: 73.4818,
    x2: 36.1735,
    y2: 74.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_29716_8594",
    x1: 69.0212,
    y1: 93.4652,
    x2: 67.4063,
    y2: 91.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_29716_8594",
    x1: 87.8805,
    y1: 78.5717,
    x2: 86.7959,
    y2: 78.3915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_29716_8594",
    x1: 61.5063,
    y1: 15.826,
    x2: 59.0833,
    y2: 15.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_29716_8594",
    x1: 92.7993,
    y1: 110.963,
    x2: 91.3403,
    y2: 111.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_29716_8594",
    x1: 104.338,
    y1: 36.4528,
    x2: 106.372,
    y2: 36.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_29716_8594",
    x1: 91.8444,
    y1: 100.585,
    x2: 90.833,
    y2: 100.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_29716_8594",
    x1: 111.52,
    y1: 45.8432,
    x2: 113.365,
    y2: 45.7919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_29716_8594",
    x1: 47.7459,
    y1: 31.8571,
    x2: 46.5806,
    y2: 31.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_29716_8594",
    x1: 45.1245,
    y1: 24.5414,
    x2: 45.2607,
    y2: 28.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_29716_8594",
    x1: 34.1668,
    y1: 86.086,
    x2: 34.9609,
    y2: 86.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_29716_8594",
    x1: 49.4565,
    y1: 46.4087,
    x2: 50.9238,
    y2: 46.1728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_29716_8594",
    x1: 45.1845,
    y1: 88.7936,
    x2: 45.6342,
    y2: 89.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_29716_8594",
    x1: 48.5481,
    y1: 46.8614,
    x2: 51.0655,
    y2: 47.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_29716_8594",
    x1: 44.1701,
    y1: 58.6143,
    x2: 45.7135,
    y2: 59.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_29716_8594",
    x1: 95.2012,
    y1: 90.4181,
    x2: 97.4065,
    y2: 87.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_29716_8594",
    x1: 66.3342,
    y1: 79.7271,
    x2: 65.4016,
    y2: 78.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_29716_8594",
    x1: 45.5406,
    y1: 94.1881,
    x2: 46.555,
    y2: 94.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_29716_8594",
    x1: 93.295,
    y1: 56.7585,
    x2: 94.02,
    y2: 59.6381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_29716_8594",
    x1: 81.2533,
    y1: 56.1053,
    x2: 82.2748,
    y2: 59.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_29716_8594",
    x1: 28.6276,
    y1: 45.6795,
    x2: 31.2506,
    y2: 46.1557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_29716_8594",
    x1: 89.42,
    y1: 6.17011,
    x2: 90.3522,
    y2: 7.93668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_29716_8594",
    x1: 94.5863,
    y1: 113.807,
    x2: 98.659,
    y2: 112.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_29716_8594",
    x1: 97.9703,
    y1: 97.2321,
    x2: 97.9276,
    y2: 98.9511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_29716_8594",
    x1: 78.2106,
    y1: 61.063,
    x2: 77.225,
    y2: 59.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_29716_8594",
    x1: 116.145,
    y1: 128.074,
    x2: 117.406,
    y2: 126.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_29716_8594",
    x1: 127.564,
    y1: 81.8172,
    x2: 129.224,
    y2: 80.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_29716_8594",
    x1: 90.9289,
    y1: 44.5235,
    x2: 93.707,
    y2: 45.6157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_29716_8594",
    x1: 74.9446,
    y1: 22.4175,
    x2: 76.8593,
    y2: 23.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_29716_8594",
    x1: 62.4154,
    y1: 78.166,
    x2: 61.1163,
    y2: 77.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_29716_8594",
    x1: 111.01,
    y1: 110.263,
    x2: 111.914,
    y2: 112.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_29716_8594",
    x1: 22.6576,
    y1: 23.1993,
    x2: 21.142,
    y2: 21.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_29716_8594",
    x1: 61.0787,
    y1: 53.5917,
    x2: 60.931,
    y2: 54.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_29716_8594",
    x1: 32.8437,
    y1: 97.1484,
    x2: 32.6737,
    y2: 99.0951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_29716_8594",
    x1: 98.3253,
    y1: 64.3111,
    x2: 98.8302,
    y2: 65.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_29716_8594",
    x1: 104.03,
    y1: 96.2113,
    x2: 105.942,
    y2: 100.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_29716_8594",
    x1: 79.2534,
    y1: 103.958,
    x2: 84.7076,
    y2: 122.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_29716_8594",
    x1: 98.7492,
    y1: 98.1333,
    x2: 103.701,
    y2: 113.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_29716_8594",
    x1: 68.2023,
    y1: 113.347,
    x2: 70.9234,
    y2: 119.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_29716_8594",
    x1: 88.7828,
    y1: 103.268,
    x2: 92.3281,
    y2: 111.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_29716_8594",
    x1: 63.1598,
    y1: 34.3194,
    x2: 69.5831,
    y2: 37.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_29716_8594",
    x1: 64.3864,
    y1: 26.0365,
    x2: 78.8952,
    y2: 35.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_29716_8594",
    x1: 68.0024,
    y1: 22.6344,
    x2: 78.5389,
    y2: 28.5738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_29716_8594",
    x1: 67.2091,
    y1: 24.0462,
    x2: 77.7455,
    y2: 29.9856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_29716_8594",
    x1: 71.5318,
    y1: 20.1925,
    x2: 77.969,
    y2: 24.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_29716_8594",
    x1: 63.4987,
    y1: 27.4736,
    x2: 78.0043,
    y2: 36.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_29716_8594",
    x1: 68.8399,
    y1: 22.7704,
    x2: 74.9463,
    y2: 25.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_29716_8594",
    x1: 66.1103,
    y1: 27.3371,
    x2: 72.4298,
    y2: 30.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_29716_8594",
    x1: 135.545,
    y1: 89.4882,
    x2: 137.603,
    y2: 96.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_29716_8594",
    x1: 142.629,
    y1: 84.9651,
    x2: 145.375,
    y2: 101.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_29716_8594",
    x1: 147.583,
    y1: 85.4388,
    x2: 150.037,
    y2: 97.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_29716_8594",
    x1: 145.993,
    y1: 85.7691,
    x2: 148.448,
    y2: 97.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_29716_8594",
    x1: 151.749,
    y1: 86.4712,
    x2: 152.956,
    y2: 93.9425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_29716_8594",
    x1: 140.954,
    y1: 85.2342,
    x2: 143.702,
    y2: 102.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_29716_8594",
    x1: 148.037,
    y1: 86.1531,
    x2: 149.993,
    y2: 92.5155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_29716_8594",
    x1: 142.776,
    y1: 87.1069,
    x2: 144.799,
    y2: 93.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_29716_8594",
    x1: 135.786,
    y1: 66.3751,
    x2: 136.452,
    y2: 91.6592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_29716_8594",
    x1: 120.169,
    y1: 74.8874,
    x2: 122.602,
    y2: 83.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_29716_8594",
    x1: 82.7828,
    y1: 79.5653,
    x2: 90.3192,
    y2: 100.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_29716_8594",
    x1: 101.788,
    y1: 72.2801,
    x2: 100.252,
    y2: 110.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_29716_8594",
    x1: 100.484,
    y1: 41.3804,
    x2: 104.736,
    y2: 45.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_29716_8594",
    x1: 87.4835,
    y1: 53.8757,
    x2: 96.228,
    y2: 59.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_29716_8594",
    x1: 93.2268,
    y1: 46.4136,
    x2: 106.706,
    y2: 52.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_29716_8594",
    x1: 93.5414,
    y1: 51.7346,
    x2: 95.5563,
    y2: 53.7615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_29716_8594",
    x1: 85.3324,
    y1: 58.6463,
    x2: 89.9118,
    y2: 64.2163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_29716_8594",
    x1: 143.714,
    y1: 40.4727,
    x2: 148.888,
    y2: 50.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_29716_8594",
    x1: 106.919,
    y1: 63.4082,
    x2: 110.778,
    y2: 75.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_29716_8594",
    x1: 136.729,
    y1: 44.6881,
    x2: 141.931,
    y2: 64.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_29716_8594",
    x1: 122.729,
    y1: 54.4426,
    x2: 127.417,
    y2: 74.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_29716_8594",
    x1: 113.953,
    y1: 61.2447,
    x2: 117.382,
    y2: 67.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_29716_8594",
    x1: 128.87,
    y1: 52.9288,
    x2: 132.517,
    y2: 59.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_29716_8594",
    x1: 71.1242,
    y1: 54.947,
    x2: 75.731,
    y2: 57.9785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_29716_8594",
    x1: 56.776,
    y1: 85.6015,
    x2: 58.5397,
    y2: 86.7621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_29716_8594",
    x1: 54.9153,
    y1: 77.3682,
    x2: 69.0618,
    y2: 87.7581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_29716_8594",
    x1: 62.6152,
    y1: 71.0893,
    x2: 67.8065,
    y2: 74.5054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_29716_8594",
    x1: 65.688,
    y1: 62.3108,
    x2: 81.4124,
    y2: 72.4464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_29716_8594",
    x1: 140.586,
    y1: 112.745,
    x2: 140.908,
    y2: 119.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_29716_8594",
    x1: 99.9674,
    y1: 120.611,
    x2: 100.09,
    y2: 123.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_29716_8594",
    x1: 106.792,
    y1: 112.908,
    x2: 106.734,
    y2: 134.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_29716_8594",
    x1: 118.521,
    y1: 115.958,
    x2: 118.882,
    y2: 123.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_29716_8594",
    x1: 129.407,
    y1: 112.693,
    x2: 130.714,
    y2: 135.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_29716_8594",
    x1: 39.9424,
    y1: 25.6081,
    x2: 47.9265,
    y2: 26.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_29716_8594",
    x1: 32.2305,
    y1: 64.8025,
    x2: 44.8918,
    y2: 61.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_29716_8594",
    x1: 38.1589,
    y1: 19.5745,
    x2: 57.483,
    y2: 18.2708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_29716_8594",
    x1: 33.5698,
    y1: 52.0578,
    x2: 52.7578,
    y2: 45.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_29716_8594",
    x1: 36.1682,
    y1: 57.6775,
    x2: 39.4436,
    y2: 57.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_29716_8594",
    x1: 36.0553,
    y1: 41.789,
    x2: 43.964,
    y2: 42.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_29716_8594",
    x1: 34.0686,
    y1: 36.402,
    x2: 58.4854,
    y2: 27.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftConfetti);
export default __webpack_public_path__ + "static/media/left-confetti.aee9cb8f53f68cab3aa0fd3025a64a03.svg";
export { ForwardRef as ReactComponent };